import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import WelcomePage from "../components/WelcomePage";
import Dashboard from "../components/Dashboard";
import "../styles/Home.css";

const Home = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="attendance-portal">
      <AnimatePresence mode="wait">
        {!showForm ? (
          <WelcomePage key="welcome" onProceed={() => setShowForm(true)} />
        ) : (
          <Dashboard key="dashboard" />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Home;
